import { render, staticRenderFns } from "./PaginationHandlerRoot.vue?vue&type=template&id=b972629e"
import script from "./PaginationHandlerRoot.vue?vue&type=script&lang=ts"
export * from "./PaginationHandlerRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports